"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var App_vue_1 = __importDefault(require("./App.vue"));
require("viewerjs/dist/viewer.css");
var v_viewer_1 = __importDefault(require("v-viewer"));
exports.default = {
    init: function (selector) {
        var element = document.querySelector(selector);
        if (element === null) {
            return;
        }
        if (!element.dataset.data) {
            throw new Error('Dataset "data" ("data-data") not found');
        }
        var newBlock = { title: '', items: [] };
        var data = __assign(__assign({}, newBlock), JSON.parse(element.dataset.data));
        vue_1.default.use(v_viewer_1.default);
        var vm = new App_vue_1.default({
            propsData: {
                data: data
            }
        });
        vm.$mount(selector);
    }
};
